export default async function copyToClipboard(content: string) {
    // asking for permission won't work on firefox
    // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API#browser_compatibility
    try {
        const result = await navigator.permissions.query({
            name: 'clipboard-write' as PermissionName,
        });
        if (result.state === 'granted' || result.state === 'prompt') {
            await navigator.clipboard.writeText(content);
            return;
        }
    } catch (error: unknown) {}

    // so write directly
    await navigator.clipboard.writeText(content);
}
